module.exports = __webpack_public_path__ + "img/manual-b.83d0bab9.png";